import { Platform, type ViewStyle } from 'react-native';

type OutsetShadowStyle = Pick<ViewStyle, 'boxShadow' | 'elevation'>;

const needsElevationFallback = Platform.OS === 'android' && Number(Platform.Version) < 28;

export function createOutsetShadow({
  offsetY,
  radius,
  color,
  androidElevation,
}: {
  offsetY: number;
  radius: number;
  color: string;
  androidElevation: number;
}): OutsetShadowStyle {
  if (needsElevationFallback) return { elevation: androidElevation };

  // Native boxShadow uses half its blur radius for the CALayer shadow radius.
  // React Native Web already interpreted the legacy radius as CSS blur pixels.
  const blurRadius = Platform.OS === 'web' ? radius : radius * 2;
  return { boxShadow: `0px ${offsetY}px ${blurRadius}px ${color}` };
}

export const noOutsetShadow: OutsetShadowStyle = needsElevationFallback ? { elevation: 0 } : { boxShadow: 'none' };
